import { render } from "./TabTitles.vue?vue&type=template&id=3908d3fe&scoped=true"
import script from "./TabTitles.vue?vue&type=script&lang=ts"
export * from "./TabTitles.vue?vue&type=script&lang=ts"

import "./TabTitles.vue?vue&type=style&index=0&id=3908d3fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3908d3fe"

export default script